// Entry point for the build script in package.json
import "@hotwired/turbo-rails"
import "./utils/custom_confirm"
import "./page_view_tracker"
import "./controllers"
import { errorTracker } from "./services/error_tracker"
import * as bootstrap from "bootstrap"

// Deliberately NOT imported here: highcharts/chartkick and d3. They are
// ~800KB minified between them and each is used by a handful of pages, so they
// build as their own esbuild entrypoints (<name>_bundle.js) and are fetched on
// demand — see utils/lazy_bundle.js. Adding any of them back to this file puts
// them on the critical path of every page again.

// Make libraries available globally
window.bootstrap = bootstrap;
// Error tracking - accessible via window.errorTracker for debugging
window.errorTracker = errorTracker;
